<template>
  <div>
    <div class="content-box">
      <left-column :navList="navList" title="联系我们" :activeNav="activeNav" :getActive="getActive"/>
      <div class="content-right">
        <div class="banner">
          <img :src="imgList[activeNav]" alt="">
        </div>
        <div class="notice-box" v-show="activeNav==1">
          <h3>胤之旅诚意招聘旅游同业、技术服务精英</h3>
          <p>请把个人简历以应聘岗位意向的标题格式：</p>
          <p>
            应聘：技术部/运营部/销售部/客服部--姓名
            **个人简历附件
          </p>
          <p>发送到人力资源邮箱：FUZIPENG@YINZHILV.COM</p>
        </div>
        <div class="notice-box" v-show="activeNav==0">
          <h3>胤之旅感谢您提出的意见和建议</h3>
          <p class="notice-box_text">如果对网站有好的建议 / 在浏览使用订购过程中有疑问 / 有意见反馈和投诉，请给我们留言，或直接联系我们。</p>
          <p>
            <b>客服电话：400-626-8448</b>
          </p>
          <p>
            <b>客服邮箱：SERVICE@YINZHILV.COM</b>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LeftColumn from "../components/leftColumn";
export default {
  data() {
    return {
      activeNav: null,
      navList: ["投诉建议", "诚聘英才"],
      imgList: [
        "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020-05-13/联系我们.jpg?x-oss-process=style/webp",
        "//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/2020-05-13/join-us.jpg?x-oss-process=style/webp"
      ]
    };
  },
  components: { LeftColumn },
  methods: {
    getActive(val) {
      this.activeNav = val;
    }
  },
  created() {
    this.activeNav = this.$route.query.type;
  }
};
</script>
<style lang="less" scoped>
.content-box {
  width: 1200px;
  margin: auto;
  margin-top: 20px;
  display: flex;
  .content-left {
    width: 238px;
    h2 {
      padding: 20px 0 15px 10px;
      font-size: 20px;
      color: #237dc8;
    }
    .content-left_text {
      font-size: 14px;
      color: #666;
      p:nth-child(1) {
        border-top: 1px solid #dfdfdf;
      }
      p {
        padding: 10px 0;
        border-bottom: 1px solid #dfdfdf;
        cursor: pointer;
        &:hover {
          color: #237dc8;
        }
      }
      i {
        color: #237dc8;
      }
    }
  }
  .content-right {
    width: 80%;
    margin-left: 51px;
    // border: 1px solid #dfdfdf;
    .banner {
      img {
        width: 100%;
        height: 185px;
      }
    }
    .notice-box {
      letter-spacing: 1px;
      h3 {
        font-size: 17px;
        font-weight: bold;
        padding: 10px 0;
      }
      &_text {
        font-size: 13px;
        color: #7b7b7b;
        width: 100% !important;
      }
      p {
        font-size: 15px;
        width: 430px;
        padding: 3px 0;
      }
    }
  }
}
</style>

